import React from 'react';
import { useNavigate } from 'react-router-dom';
import { defaultTheme } from '../../styles/themes/defaultTheme';


const data = {
    userId: 'NKALEYIAS',
    dimensions: [
        { name: 'D_RB_BU_SBU', warehouse: 'MDW', accessType: 'Role' },
        { name: 'D_RB_CUST', warehouse: 'MDW', accessType: 'Role' },
        { name: 'D_RB_OMBU', warehouse: 'MDW', accessType: 'Role' },
        { name: 'D_RB_PROD', warehouse: 'MDW', accessType: 'Role' },
        { name: 'D_RB_SOG', warehouse: 'MDW', accessType: 'Role' }
    ],
    roles: [
        { name: 'RB_ALL_BU_SBU', description: 'BU_SBU DIMENSION-ALL ACCESS' },
        { name: 'RB_ALL_CUST', description: 'CUSTOMER DIMENSION-ALL ACCESS' },
        { name: 'RB_ALL_OMBU', description: 'OMBU DIMENSION-ALL ACCESS' },
        { name: 'RB_ALL_PROD', description: 'PRODUCT DIMENSION-ALL ACCESS' },
        { name: 'RB_ALL_SOG', description: 'SOG DIMENSION-ALL ACCESS' }
    ]
};

export default function UserSummary() {
    const navigate = useNavigate();
    return (
        <div style={{ background: defaultTheme.colors.background, color: defaultTheme.colors.text, padding: "0px" }}>
            <div className="card-header p-3" style={{ backgroundColor: defaultTheme.colors.primary, color: "white" }}>
                <h2>User Security Summary</h2>
                <label>User ID: </label>
                <input type="text" defaultValue={data.userId} style={{ borderColor: defaultTheme.colors.border, marginRight: 10 }} />
                <button style={{ background: "green", color: 'white', padding: '5px 10px', border: '1px solid gray', borderRadius: "8px" }}>Display Summary</button>
            </div>
            <div className="card-header px-3 mt-4 py-1" style={{ backgroundColor: defaultTheme.colors.primary, color: "white" }}>
                <h3>Dimension Access</h3>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20 }}>
                <thead>
                    <tr>
                        <th style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>Dimension Name</th>
                        <th style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>Warehouse</th>
                        <th style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>Access Type</th>
                        <th style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>Edit Access</th>
                    </tr>
                </thead>
                <tbody>
                    {data.dimensions.map((dim, i) => (
                        <tr key={i}>
                            <td style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>{dim.name}</td>
                            <td style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>{dim.warehouse}</td>
                            <td style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>{dim.accessType}</td>
                            <td style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>
                                <a href="#" style={{ color: defaultTheme.colors.primary }}>Edit Access</a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="card-header px-3 mt-4 py-1" style={{ backgroundColor: defaultTheme.colors.primary, color: "white" }}>
                <h3>Roles</h3>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>EPM Security Role Name</th>
                        <th style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {data.roles.map((role, i) => (
                        <tr key={i}>
                            <td style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }} onClick={() => {
                                navigate("/roles/roledetails")
                            }}>{role.name}</td>
                            <td style={{ border: `1px solid ${defaultTheme.colors.border}`, padding: 8 }}>{role.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* <p style={{ fontSize: 12, color: defaultTheme.colors.secondary, marginTop: 20 }}>
                Note: Changes will not take effect until security is rebuilt
            </p> */}
        </div>
    );
}
